import { render, staticRenderFns } from "./ViewReleasesHome.vue?vue&type=template&id=d4d18e08"
import script from "./ViewReleasesHome.vue?vue&type=script&lang=js"
export * from "./ViewReleasesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports